import { Component, OnInit } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  AlertController
} from 'ionic-angular';

import { AuthProvider } from '../../providers/auth/auth';

@Component({
  selector: 'page-privacy-settings',
  templateUrl: 'privacy-settings.html'
})
export class PrivacySettingsPage implements OnInit {
  title = 'Privacy Settings';
  currentUser: any;
  currentUserSubscription: any;
  userDataLoaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController
  ) {}

  ngOnInit() {
    let loader = this.loadingCtrl.create({
      content: 'Loading jobs...'
    });
    loader.present();

    this.authProvider.getFbUser().then(fbUser => {
      console.log(fbUser);
      this.currentUserSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          data => {
            console.log(data);
            this.currentUser = data;
            loader.dismiss();
            this.userDataLoaded = true;
            return data;
          },
          err => {
            console.log(err);
          }
        );
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PrivacySettingsPage');
  }

  toggleAccountNotifications(evt) {
    console.log(evt);
    let loader = this.loadingCtrl.create({
      content: 'Updating profile...'
    });
    loader.present();

    this.authProvider
      .updateAccountNotifications(this.currentUser.uid, evt.checked)
      .then(() => {
        loader.dismiss();
        let alert = this.alertCtrl.create({
          title: 'Update successful!',
          message: 'Your updated profile information has been saved.',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                console.log('Ok clicked');
              }
            }
          ]
        });
        alert.present();
      })
      .catch(err => {
        console.log(err);
      });
  }

  toggleTrainingNotifications(evt) {
    console.log(evt);
    let loader = this.loadingCtrl.create({
      content: 'Updating profile...'
    });
    loader.present();

    this.authProvider
      .updateTrainingNotifications(this.currentUser.uid, evt.checked)
      .then(() => {
        loader.dismiss();
        let alert = this.alertCtrl.create({
          title: 'Update successful!',
          message: 'Your updated profile information has been saved.',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                console.log('Ok clicked');
              }
            }
          ]
        });
        alert.present();
      })
      .catch(err => {
        console.log(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/privacy-settings/privacy-settings.ts